import React from 'react'
import { useState,useEffect } from 'react';
import { mainTable } from '../css/Common';
import InputText from '../ReusableComponents/InputText';
import DropDown from '../ReusableComponents/DropDown';
import TextArea from '../ReusableComponents/TextArea';


const EnquiryLostViewPopUp = ({data,data1,isOpen}) => {

     const [tableData, setTableData] = useState([]);
      const handleCancel = () => {
    isOpen(false);
  };

    useEffect(() => {
      if (data1?.length > 0) {
        setTableData(data1);
  
        const initialForm = data1.map(() => ({
          reasonforlost: "",
          lostnotes: "",
        }));
       // setLostFormData(initialForm);
  
        
        
      }
    }, [data1]);


  return (
   <>
      <div className="mx-auto p-8 maxw-7xl">
        <div className={mainTable.grid3}>
          <InputText
            inputType="text"
            title="Enquiry ID"
            name="enquiryid"
            content={data?.enquiryid || ""}
            disabled={true}
            // tabIndex="11"
            isRequired={true}
            
          />

          <InputText
            inputType="date"
            title="Booking From"
            name="fromdate"
            content={data?.fromdate || ""}
            disabled={true}
            // tabIndex="9"
            isRequired={true}
          />

          <InputText
            inputType="date"
            title="Booking To"
            name="todate"
            content={data?.todate || ""}
            disabled={true}
            // tabIndex="9"
            isRequired={true}
          />

          <InputText
            inputType="text"
            title="First Name"
            name="fname"
            content={data?.fname || ""}
            disabled={true}
            // tabIndex="1"
            isRequired={true}
            classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Last Name"
            name="lname"
            content={data?.lname || ""}
            disabled={true}
            // tabIndex="2"
            isRequired={true}
            // classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Mobile Number"
            name="number"
            content={data?.number || ""}
            disabled={true}
            // tabIndex="3"
            isRequired={true}
            classStar="text-red-500"
          />
        </div>

        <TextArea
                  title="Notes"
                  name="lostnotes"
                  placeholder="Describe here"
                  rows="3"
                 disabled='true'
                 content={data1.LostReasonNotes}
                  isRequired={true}
                />
              

        
      </div>

      {/* Room List Section */}
         <div className="mx-auto p-4 max-w-7xl">
              <ul className="space-y-4">
                {tableData?.map((room, index) => (
                  <li
                    key={index}
                    className="border border-green-500 rounded-md p-4 shadow-sm bg-white"
                  >
                    <div className="flex flex-col items-start justify-between">
                      
      
                      <h2 className="text-lg font-semibold text-gray-800 mb-2">
                        {room.RoomName}
                      </h2>
      
                      <div className="flex flex-col md:flex-row items-start md:gap-x-10">
                        <img
                          src={room.Photo}
                          alt="Room"
                          className="h-48 w-36 object-cover rounded-md border"
                        />
      
                        <div className="flex-1 flex-col w-full">
                          <div className="flex flex-col md:flex-row md:gap-x-12 flex-1">
                            {/* Room Details */}
                            <div className="space-y-1">
                              <p className="text-sm font-semibold text-gray-600">
                                Room Details
                              </p>
                              <p className="text-sm text-gray-600">
                                Property Size: {room.Size}
                              </p>
                              <p className="text-sm text-gray-600">
                                Max Occupancy: {room.MaxOccupancy}
                              </p>
                              <p className="text-sm text-gray-600">
                                Villa Type: {room.RoomType}
                              </p>
                            </div>
      
                            {/* Space Details */}
                            <div className="space-y-1">
                              <p className="text-sm font-semibold text-gray-600">
                                Space Details
                              </p>
                              {room.SpaceDetails ? (
                                <ul className="text-sm text-gray-600">
                                  {room.SpaceDetails.split(",").map((item, idx) => (
                                    <li key={idx}>
                                      {idx + 1}. {item.trim()}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <p className="text-sm text-gray-600">Not Available</p>
                              )}
                            </div>
      
                            {/* Amenities */}
                            <div className="space-y-1">
                              <p className="text-sm font-semibold text-gray-600">
                                Amenities
                              </p>
                              {room.AmenitiesDetails ? (
                                <ul className="text-sm text-gray-600">
                                  {room.AmenitiesDetails.split(",").map(
                                    (item, idx) => (
                                      <li key={idx}>
                                        {idx + 1}. {item.trim()}
                                      </li>
                                    )
                                  )}
                                </ul>
                              ) : (
                                <p className="text-sm text-gray-600">Not Available</p>
                              )}
                            </div>
                          </div>
      
                          {/* Room selection and reason */}
                          <div className="flex flex-row justify-between gap-8 mt-4">
                            <div className="flex flex-col gap-2">
                              <p className="text-sm font-semibold text-gray-700">
                                Rooms: {room.NoOfRequiredRooms}
                              </p>
                              {/* <div className="flex gap-2 flex-wrap">
                                {Array.from(
                                  { length: room.NoOfRequiredRooms },
                                  (_, idx) => {
                                    const number = idx + 1;
                                    return (
                                      <span
                                        key={idx}
                                        className="inline-block px-3 py-2 h-8 text-sm font-medium rounded-md text-white bg-green-500"
                                      >
                                        {number}
                                      </span>
                                    );
                                    
                                  }
                                )}
                              </div> */}

<div className="flex gap-2 flex-wrap">
  {Array.from(
    { length: Number(room.NoOfRequiredRooms || 0) },
    (_, idx) => {
      const label = `${room.RoomType} ${idx + 1}`;

      return (
        <span
          key={idx}
          className="inline-block px-3 py-2 h-8 text-sm font-medium rounded-md text-white bg-green-500"
        >
          {label}
        </span>
      );
    }
  )}
</div>
                            </div>
      
                            {/* Dropdown */}
                            <div className="text-gray-900 text-sm rounded-lg">
                              <div className={mainTable.grid3}>
                                {/* <DropDown
                                  name="reasonforlost"
                                  title="Reason for Lost"
                                  type="select-one"
                                  options={{value:room.LostReason,label:room.LostReason}}
                                  selectedOption={
                                  room.LostReason
                                  }
                               
                                  placeholder="Select reason"
                                /> */}

<DropDown
  name="reasonforlost"
  title="Reason For Lost"
  disabled={true}
  options={
    room.LostReason
      ? [{ value: room.LostReason, label: room.LostReason }]
      : []
  }
  selectedOption={room.LostReason}
  placeholder="Select reason"
/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

      {/* Footer Buttons */}
      <div className="h-28 flex justify-center items-center gap-4">
        
        <button
          type="button"
          className={mainTable.cancelButton}
          onClick={() => handleCancel()}
        >
          Cancel
        </button>
      </div>
    </>
  )
}

export default EnquiryLostViewPopUp
